"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const d3 = __importStar(require("d3"));
const DistroLoaderInline_vue_1 = __importDefault(require("./DistroLoaderInline.vue"));
const ViewZeroDistro_vue_1 = __importDefault(require("../components/ViewZeroDistro.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const parcel_1 = __importDefault(require("../controllers/services/parcel"));
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let Graphic = class Graphic extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.colorManager = new ColorLibController_1.default();
        this.svgg = null;
        this.xx = null;
        this.myHeight = null;
        this.divTop = null;
        this.divBottom = null;
    }
    categoryText(category) {
        if (category)
            return this.colorManager.getCategoryTitle(category);
        return '';
    }
    categoryColor(category) {
        if (category)
            return this.colorManager.getCategoryColor(category.toLowerCase());
        return '';
    }
    categoryTransform(category) {
        if (category)
            return this.colorManager.getAlphaCategory(category);
        return '';
    }
    calculateCSSClasses(category) {
        if (category)
            return this.colorManager.getCSSClassesForCategory(category);
        return '';
    }
    mounted() {
        this.createDensityChart();
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 55, 55);
    }
    updateBottomString() {
        var _a;
        const myClasses = this.calculateCSSClasses(this.currentAverage.category);
        return '<div class="container-category-example"><p>' + ((_a = this.currentAverage.area) === null || _a === void 0 ? void 0 : _a.areaName) + '</p><div class="' + myClasses + '"><p>' + this.currentAverage.score + ' - ' + this.categoryText(this.currentAverage.category).toUpperCase() + '</p></div></div>';
    }
    updateTopString() {
        const myClasses = this.calculateCSSClasses(this.currentAverage.category);
        return '<div class="circle-category ' + myClasses + '"><p>' + this.currentAverage.category + '</p></div></div>';
    }
    createDensityChart() {
        d3.select(`#${this.chartId}`).selectAll('svg').remove();
        const containerWidth = document.getElementById(this.chartId).clientWidth;
        const margin = { top: 80, right: 10, bottom: 25, left: 70 };
        const width = containerWidth - margin.left - margin.right - 150;
        const height = this.items.length <= 3
            ? this.items.length * 250 - margin.top - margin.bottom
            : this.items.length * 100 - margin.top - margin.bottom;
        const svg = d3
            .select(`#${this.chartId}`)
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);
        const yMapping = (yValue) => {
            if (yValue > 1000 && yValue < 1100) {
                return 1010;
            }
            else if (yValue >= 1100 && yValue < 1200) {
                return 1020;
            }
            else if (yValue >= 1300 && yValue < 1400) {
                return 1030;
            }
            else if (yValue >= 1400 && yValue < 1500) {
                return 1040;
            }
            else if (yValue >= 1500 && yValue < 1600) {
                return 1050;
            }
            else if (yValue >= 1600 && yValue < 1700) {
                return 1060;
            }
            else if (yValue >= 1700 && yValue < 1800) {
                return 1070;
            }
            else if (yValue >= 1800 && yValue < 1900) {
                return 1080;
            }
            else if (yValue >= 1900 && yValue < 1000) {
                return 1090;
            }
            else if (yValue <= 1000) {
                return yValue;
            }
            else {
                return 1100;
            }
        };
        let exampleData = this.items.map((data) => (Object.assign(Object.assign({}, data), { points: data.points.map((point) => ({
                x: point.x,
                y: yMapping(point.y),
            })) })));
        if (this.dimension === 'crop') {
            exampleData = exampleData.sort((a, b) => {
                var _a, _b;
                const includesCropNameA = a.meta.id_crop === ((_a = this.currentAverage.crop) === null || _a === void 0 ? void 0 : _a.id);
                const includesCropNameB = b.meta.id_crop === ((_b = this.currentAverage.crop) === null || _b === void 0 ? void 0 : _b.id);
                if (includesCropNameA && !includesCropNameB) {
                    return -1; // a debe ir antes que b
                }
                else if (!includesCropNameA && includesCropNameB) {
                    return 1; // b debe ir antes que a
                }
                else {
                    // Ambos elementos tienen o no tienen el nombre del cultivo en meta.label
                    // Ordenar por statistics.avg de mayor a menor
                    return b.statistics.avg - a.statistics.avg;
                }
            });
        }
        else {
            exampleData = exampleData.sort((a, b) => {
                const includesCropNameA = a.meta.label.includes(this.currentAverage.country);
                const includesCropNameB = b.meta.label.includes(this.currentAverage.country);
                if (includesCropNameA && !includesCropNameB) {
                    return -1; // a debe ir antes que b
                }
                else if (!includesCropNameA && includesCropNameB) {
                    return 1; // b debe ir antes que a
                }
                else {
                    // Ambos elementos tienen o no tienen el nombre del cultivo en meta.label
                    // Ordenar por statistics.avg de mayor a menor
                    return b.statistics.avg - a.statistics.avg;
                }
            });
        }
        const categories = exampleData.map((d) => ({
            label: d.meta.label,
            slug: d.meta.slug,
            cropLogo: d.meta.cropLogo,
            id: d.meta.id_crop,
        }));
        const n = categories.length;
        const x = d3.scaleLinear().domain([40, 100]).range([0, width]);
        svg.append('g')
            .attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x));
        const maxDataY = d3.max(exampleData, (d) => d3.max(d.points, (point) => point.y));
        const halfMaxDataY = maxDataY / 2;
        const y = d3.scaleLinear().domain([0, halfMaxDataY]).range([height, 0]);
        const categoryLabels = categories.map((category) => category.label);
        let yName;
        const shouldHighlightCategory = (category) => {
            var _a;
            let categoryCurrent = null;
            for (const cat of categories) {
                if (cat.label === category) {
                    categoryCurrent = cat;
                }
            }
            return (categoryCurrent === null || categoryCurrent === void 0 ? void 0 : categoryCurrent.id) === ((_a = this.currentAverage.crop) === null || _a === void 0 ? void 0 : _a.id);
        };
        if (this.dimension === 'crop') {
            yName = d3
                .scaleBand()
                .domain(categoryLabels)
                .range([0, height])
                .paddingInner(1);
            // Añadir el eje y al SVG
            svg.append('g')
                .attr('class', 'y axis')
                .call(d3.axisLeft(yName).tickPadding(40))
                .selectAll('.tick text') // Seleccionar los elementos de texto de las marcas del eje y
                .style('fill', function (d) {
                return shouldHighlightCategory.call(this, d) ? '#bfa628' : 'black';
            })
                .style('font-size', function (d) {
                return shouldHighlightCategory.call(this, d) ? '13px' : '11px';
            });
            const yNameGroup = svg.append('g');
            yNameGroup
                .selectAll('.category-image')
                .data(categories)
                .enter()
                .append('image')
                .attr('class', 'category-image')
                .attr('x', -40)
                .attr('y', (d) => yName(d.label) + yName.bandwidth() / 2 - 20)
                .attr('width', 35)
                .attr('height', 35)
                .attr('xlink:href', (d) => `/crop/pic/color/${d.cropLogo}/Soil`);
        }
        else {
            yName = d3
                .scaleBand()
                .domain(categoryLabels)
                .range([0, height])
                .paddingInner(1);
            svg.append('g').call(d3.axisLeft(yName).tickPadding(20));
        }
        function kernelDensityEstimator(kernel, X) {
            return (V) => {
                return X.map((x) => {
                    const densityValues = V.map((v) => kernel(x - v.x) * v.y);
                    const sumOfDensityValues = densityValues.reduce((sum, density) => sum + density, 0);
                    return [x, sumOfDensityValues];
                });
            };
        }
        function kernelEpanechnikov(k) {
            return (v) => {
                const normalizedV = v / k;
                return Math.abs(normalizedV) <= 1
                    ? (0.7 * (1 - normalizedV * normalizedV)) / k
                    : 0;
            };
        }
        function kernelTriangular(k) {
            return (v) => {
                const normalizedV = v / k;
                return Math.abs(normalizedV) <= 1 ? (1 - Math.abs(normalizedV)) / k : 0;
            };
        }
        function kernelLaplace(k) {
            return (v) => {
                const normalizedV = Math.abs(v) / k;
                return (1 / (2 * k)) * Math.exp(-normalizedV);
            };
        }
        function kernelSinc(k) {
            return (v) => {
                const scaledV = (Math.PI * v) / k;
                return Math.sin(scaledV) / scaledV;
            };
        }
        function kernelCosine(k) {
            return (v) => {
                const scaledV = (Math.PI * v) / (2 * k);
                return (Math.cos(scaledV) + 1) / (2 * k);
            };
        }
        function kernelCauchy(k) {
            return (v) => {
                const scaledV = (Math.PI * v) / k;
                return 1 / (Math.PI * k * (1 + scaledV * scaledV));
            };
        }
        const kde = kernelDensityEstimator(kernelCauchy(8), x.ticks(2000));
        const allDensity = [];
        for (let i = 0; i < n; i++) {
            const key = categories[i].label;
            const density = kde(exampleData[i].points.map((d) => d.x));
            allDensity.push({ key, density });
        }
        const gradientScale = d3
            .scaleLinear()
            .domain([0, 49, 59, 69, 79, 89, 100])
            .range([0, 1, 2, 3, 4, 5, 6]);
        svg.selectAll('.vertical-line')
            .data(x.ticks(40))
            .enter()
            .filter((d) => d % 10 === 0 && d !== -10)
            .append('line')
            .attr('class', 'vertical-line')
            .attr('x1', (d) => x(d))
            .attr('y1', 0)
            .attr('x2', (d) => x(d))
            .attr('y2', height)
            .attr('stroke', '#000')
            .attr('opacity', 0.4)
            .attr('stroke-width', 1)
            .attr('stroke-dasharray', '3,3');
        const gradientColors = [
            '#e47c79',
            '#ff9a51',
            '#efcf32',
            '#e6d581',
            '#a1e681',
            '#67bf3e',
        ];
        svg.append('mask')
            .attr('id', 'wave-mask')
            .append('rect')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', width)
            .attr('height', height)
            .attr('fill', 'url(#gradient)');
        const gradient = svg
            .append('linearGradient')
            .attr('id', 'gradient')
            .attr('x1', '0%')
            .attr('x2', '100%')
            .attr('y1', '0%')
            .attr('y2', '0%');
        gradient
            .selectAll('stop')
            .data(gradientColors)
            .enter()
            .append('stop')
            .attr('offset', (_, i) => (i * 100) / (gradientColors.length - 1) + '%')
            .attr('stop-color', (d) => d);
        svg.selectAll('.areas')
            .data(exampleData)
            .enter()
            .append('path')
            .attr('class', 'areas')
            .attr('transform', (d) => `translate(0,${yName(d.meta.label) - height})`)
            .datum((d) => kde(d.points))
            .attr('stroke', '#000')
            .attr('stroke-width', 1)
            .attr('d', (density) => {
            const startPointX = density[0][0];
            const startPointY = y(0);
            return (`M${x(startPointX)},${startPointY}` + // Start with a vertical line
                d3
                    .line()
                    .curve(d3.curveBasis)
                    .x((d) => x(d[0]))
                    .y((d) => y(0))(density)); // Use the curve with y values
        })
            .style('fill', 'url(#gradient)')
            .attr('mask', 'url(#wave-mask)')
            .transition()
            .duration(1000)
            .attr('d', (density) => {
            return (d3
                .line() // Specify the type of data for the line
                .curve(d3.curveBasis)
                .x((d) => x(d[0]))
                .y((d) => y(d[1]))(density) +
                `L${x(density[density.length - 1][0])},${y(0)}` +
                `L${x(0)},${y(0)}`); // Line to the last point with zero y
        });
        const areasWithXIntersection = allDensity.filter((d) => d.density.some((point) => point[0] === 20));
        svg.selectAll('.gap-fill')
            .data(areasWithXIntersection)
            .enter()
            .append('rect')
            .attr('class', 'gap-fill')
            .attr('x', 0)
            .attr('y', (d) => yName(d.key) + 50)
            .attr('width', width)
            .style('fill', 'url(#gradient)');
        this.svgg = svg;
        this.xx = x;
        this.myHeight = height;
        this.createLine();
        this.repositionLineAndDivs(0);
    }
    createLine() {
        this.svgg
            .append('line')
            .attr('x1', this.xx(this.linePosition))
            .attr('y1', -70)
            .attr('x2', this.xx(this.linePosition))
            .attr('y2', this.myHeight + 30)
            .attr('class', 'bmfw-stroke-bmk_certificate_' +
            this.categoryTransform(this.currentAverage.category).toLowerCase())
            .attr('stroke-width', 3)
            .attr('id', 'divBelowLine');
        const contentTop = document.querySelector('#contentTop').innerHTML;
        const contentBottom = document.querySelector('#contentBottom').innerHTML;
        const divTop = this.svgg
            .append('foreignObject')
            .attr('id', 'topObject')
            .attr('x', this.xx(this.linePosition) - 50)
            .attr('y', -100)
            .attr('width', 100)
            .attr('height', 50)
            .append('xhtml:div')
            .attr('id', 'top')
            .style('text-align', 'center')
            .style('display', 'flex')
            .style('justify-content', 'center')
            .style('align-items', 'center')
            .html(contentTop);
        const divBottom = this.svgg
            .append('foreignObject')
            .attr('id', 'bottomObject')
            .attr('x', this.xx(this.linePosition) - 100)
            .attr('y', 25 + this.myHeight + 10)
            .attr('width', 200)
            .attr('height', 100)
            .append('xhtml:div')
            .attr('id', 'bo')
            .style('text-align', 'center')
            .style('display', 'flex')
            .style('justify-content', 'center')
            .style('align-items', 'center')
            .html(contentBottom);
        this.divTop = divTop;
        this.divBottom = divBottom;
    }
    repositionLineAndDivs(time) {
        const line = this.svgg.select('#divBelowLine');
        const topElement = this.svgg.select('#topObject');
        const bottomElement = this.svgg.select('#bottomObject');
        const contentTop = this.updateTopString();
        const contentBottom = this.updateBottomString();
        if (line.size() === 1) {
            line.transition()
                .duration(700)
                .attr('class', '')
                .attr('stroke', this.categoryColor(this.currentAverage.category))
                .attr('x1', this.xx(this.linePosition))
                .attr('x2', this.xx(this.linePosition));
            topElement
                .transition()
                .duration(700)
                .attr('x', this.xx(this.linePosition) - 50);
            topElement
                .select('#top')
                .remove();
            topElement
                .append('xhtml:div')
                .attr('id', 'top')
                .style('text-align', 'center')
                .style('display', 'flex')
                .style('justify-content', 'center')
                .style('align-items', 'center')
                .html(contentTop);
            bottomElement
                .transition()
                .duration(700)
                .attr('x', this.xx(this.linePosition) - 100);
            bottomElement
                .select('#bo')
                .remove();
            bottomElement
                .append('xhtml:div')
                .attr('id', 'bo')
                .style('text-align', 'center')
                .style('display', 'flex')
                .style('justify-content', 'center')
                .style('align-items', 'center')
                .html(contentBottom);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'density-chart' })
], Graphic.prototype, "chartId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], Graphic.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], Graphic.prototype, "currentAverage", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], Graphic.prototype, "linePosition", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'crop' })
], Graphic.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], Graphic.prototype, "isLoading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], Graphic.prototype, "distribution", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items')
], Graphic.prototype, "createDensityChart", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('linePosition')
], Graphic.prototype, "repositionLineAndDivs", null);
Graphic = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { DistroLoaderInline: DistroLoaderInline_vue_1.default, ViewZeroDistro: ViewZeroDistro_vue_1.default, Chart2Icon: bmk_ui_framework_1.Chart2Icon },
    })
], Graphic);
exports.default = Graphic;
